import { createFileRoute } from '@tanstack/react-router';
import { BancosDeDadosView } from '@/modules/agronomia/components/BancosDeDadosView';

// Tela "Bancos de Dados" — destino do pipe homônimo da seleção do módulo
// Agronomia (desktop). Lista os bancos de dados; hoje só Insumos.
export const Route = createFileRoute('/_authed/agronomia_/bancos-de-dados')({
  component: BancosDeDadosView,
});
